module.exports = __webpack_public_path__ + "img/wf.0000be80.svg";